var map = {
	"./12 stage property.jpg": "9b53",
	"./3_Budaya Politik Matang.jpg": "5b39",
	"./3_WKS hand.jpg": "4123",
	"./3_buku harapan.jpg": "7e88",
	"./3_cabinet.jpg": "d334",
	"./3_chess.jpg": "3e78",
	"./3_hadi fish.jpg": "0c8c",
	"./3_muhyiddin knife.jpg": "1826",
	"./3_muhyiddin3.jpg": "e218",
	"./3_parlimen.jpg": "79f4",
	"./3_treasure chest3.jpg": "41e9",
	"./3bn.jpg": "eaeb",
	"./3ph.jpg": "1607",
	"./4_hishamuddin shirt.jpg": "8af9",
	"./4_sheraton.jpg": "acc8",
	"./5leader.jpg": "210a",
	"./Azmin_key.jpg": "b69e",
	"./LGE_3.jpg": "15f5",
	"./LKS.jpg": "0167",
	"./LKS_3.jpg": "d972",
	"./LKS_eyes.jpg": "558c",
	"./LKS_mouth.jpg": "ef83",
	"./LV shoe.jpg": "ff4c",
	"./Mahathir.jpg": "2134",
	"./Mahathir_3.jpg": "791e",
	"./Mahathir_eyes.jpg": "49f4",
	"./Mahathir_mouth.jpg": "008f",
	"./Mat Sabu.jpg": "080c",
	"./Mat Sabu_3.jpg": "1d54",
	"./Mat Sabu_eyes.jpg": "96e6",
	"./Mat Sabu_mouth.jpg": "1ec2",
	"./WKS.jpg": "7de8",
	"./WKS_3.jpg": "c7ea",
	"./WKS_eyes.jpg": "8a13",
	"./WKS_mouth.jpg": "624c",
	"./Zulaida.jpg": "cb4c",
	"./Zulaida_3.jpg": "c4ee",
	"./Zulaida_eyes.jpg": "8468",
	"./Zulaida_mouth.jpg": "95bb",
	"./all_eye.jpg": "eeae",
	"./all_head copy.jpg": "0640",
	"./all_head_black copy.jpg": "607a",
	"./all_mouth.jpg": "6456",
	"./anwar.jpg": "160c",
	"./anwar_3.jpg": "e0df",
	"./anwar_eyes.jpg": "d639",
	"./anwar_mouth.jpg": "5344",
	"./azmin.jpg": "551f",
	"./azmin_3.jpg": "d38c",
	"./azmin_eyes.jpg": "e2ec",
	"./azmin_mouth.jpg": "6bfc",
	"./azmin_zuraida.jpg": "858c",
	"./backdoor.jpg": "4922",
	"./bn_side copy.jpg": "2ecb",
	"./buku harapan.jpg": "7f37",
	"./cabinet.jpg": "6d01",
	"./call.jpg": "a0ef",
	"./covid pattern.jpg": "344c",
	"./covid.jpg": "2859",
	"./flower_pattern.jpg": "84e6",
	"./full_artwork.jpg": "08f8",
	"./full_black.jpg": "fe93",
	"./full_black2.jpg": "bc5a",
	"./full_blue.jpg": "0288",
	"./full_green.jpg": "df2f",
	"./full_lightblue.jpg": "1ad6",
	"./full_orange.jpg": "3e87",
	"./full_red.jpg": "cf2a",
	"./hadi.jpg": "8e1e",
	"./hadi_3.jpg": "1eb5",
	"./hadi_eyes.jpg": "6a18",
	"./hadi_mouth.jpg": "ed08",
	"./hand.jpg": "833d",
	"./head_color.jpg": "8e8a",
	"./hishamuddin.jpg": "bab4",
	"./hishamuddin_3.jpg": "b661",
	"./hishamuddin_eyes.jpg": "c668",
	"./hishamuddin_mouth.jpg": "5b52",
	"./item_color.jpg": "77e1",
	"./lim guan eng.jpg": "8d2f",
	"./lim guan eng_eyes.jpg": "cf83",
	"./lim guan eng_mouth.jpg": "c606",
	"./lks_speaker_najib.jpg": "f387",
	"./ma_anwar.jpg": "a83c",
	"./ma_najib.jpg": "149e",
	"./muhyiddin.jpg": "a491",
	"./muhyiddin_3.jpg": "2cd4",
	"./muhyiddin_eyes.jpg": "a894",
	"./muhyiddin_mouth.jpg": "e741",
	"./najib.jpg": "f7f0",
	"./najib_3.jpg": "1c5c",
	"./najib_eyes.jpg": "d6f5",
	"./najib_mouth.jpg": "6ab9",
	"./najib_zahid.jpg": "6204",
	"./parliamen_logo.jpg": "bf23",
	"./parlimen Malaysia.jpg": "61d0",
	"./ph_side copy.jpg": "e772",
	"./shafie.jpg": "e33e",
	"./shafie_3.jpg": "e231",
	"./shafie_eyes.jpg": "bf4e",
	"./shafie_mouth.jpg": "df4b",
	"./speaker_eyes.jpg": "48a7",
	"./spesker.jpg": "08ec",
	"./spesker_3.jpg": "3c4d",
	"./spesker_mouth.jpg": "26d5",
	"./tony_artwork.jpg": "3233",
	"./zahid.jpg": "1759",
	"./zahid_3.jpg": "e3f7",
	"./zahid_eyes.jpg": "4c36",
	"./zahid_mouth.jpg": "f5a1",
	"./zuraida_wks.jpg": "3aa7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "95f8";